module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-1x1_5-89d27e9902b02a9aee9d4ccf8c0a7932.jpg";